<div role="list" class="staff-links text-start margin-left-3 margin-top-10 width-100">
  @for (item of actionItems; track item) {
    <a
      role="listitem"
      tabindex="0"
      [attr.aria-label]="item.label"
      (agInteract)="handleFullRecordAction(item.action)"
      >{{ item.label }}</a
    >
  }
</div>
